import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import FormLayout from 'src/layouts/form';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

const DashboardLayoutStore = lazy(() =>
  import('src/layouts/dashboard/layout').then((module) => ({ default: module.DashboardLayoutStore }))
);
const FormEditionStore = lazy(() =>
  import('src/pages/form/FormEdition').then((module) => ({ default: module.FormEditionStore }))
);
const FormViewStore = lazy(() =>
  import('src/pages/form/FormView').then((module) => ({ default: module.FormViewStore }))
);
const FormFillingOutStore = lazy(() =>
  import('src/pages/form/FormFillingOut').then((module) => ({
    default: module.FormFillingOutStore,
  }))
);
const FormByParticipantStore = lazy(() =>
  import('src/pages/form/FormByParticipant').then((module) => ({
    default: module.FormByParticipantStore,
  }))
);
const ParticipantByFormStore = lazy(() =>
  import('src/pages/form/ParticipantByForm').then((module) => ({
    default: module.ParticipantByFormStore,
  }))
);
const FormResultsStore = lazy(() =>
  import('src/pages/form/FormResults').then((module) => ({
    default: module.FormResultsStore,
  }))
);
const StatisticPageStore = lazy(() =>
  import('src/pages/statistic/StatisticPage').then((module) => ({
    default: module.StatisticPageStore,
  }))
);

const StatisticTrainingPageStore = lazy(() =>
  import('src/pages/statistic/StatisticsByTrainingPage').then((module) => ({
    default: module.StatisticTrainingPageStore,
  }))
);

const StatisticDetailByForm = lazy(() => import('src/pages/statistic/StatisticDetailByForm'));
const StatisticByTraineePage = lazy(() => import('src/pages/statistic/StatisticsByTraineePage'));
const StatisticBySessionPage = lazy(() => import('src/pages/statistic/StatisticsBySessionPage'));
const StatisticDetailByTrainee = lazy(() => import('src/pages/statistic/StatisticDetailByTrainee'));
const OrderListView = lazy(() => import('src/components/form/dataTables/sessions'));

// ----------------------------------------------------------------------

export const statisticOrganizationRoutes = [
  {
    path: 'forms/statistics',
    element: (
      <AuthGuard allowedRoles={['organization', 'manager']}>
        <DashboardLayoutStore>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayoutStore>
      </AuthGuard>
    ),
    children: [
      { element: <StatisticPageStore />, index: true },
      { path: 'participants', element: <StatisticByTraineePage /> },
      { path: 'forms/details', element: <StatisticDetailByForm /> },
      { path: 'participants/details', element: <StatisticDetailByTrainee /> },
      { path: 'sessions', element: <StatisticBySessionPage /> },
      { path: 'trainings', element: <StatisticTrainingPageStore /> },
    ],
  },
];

